export default __webpack_public_path__ + "assets/_Chapters/Karriere/Zitate/ausbildung-und-studium-2.webp";